import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Badge, Card, Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useGetDta } from '../../../hooks/useGetDta';
import LoadinSpin from '../../ui/LoadinSpin';

const ContratoUs = ({ activeTab }) => {
    const { id } = useParams();

    let idR = atob(id);
    const { loading, data, getInfo } = useGetDta(`user/docdigital/${idR}`);

    useEffect(() => {
        if (activeTab === 'docs') getInfo();
    }, [activeTab, idR]);
    if (loading) return <LoadinSpin />;
    return (
        <Card>
            <Card.Header className="text-primary fs-4 fw-bold">FIRMA DEL CONTRATO</Card.Header>
            <Card.Body>
                <Table responsive className="table-centered table-nowrap mb-0">
                    <thead>
                        <tr>
                            <th scope="col">Firmante</th>
                            <th scope="col">link</th>
                            <th scope="col">Estatus de la firma</th>
                            <th scope="col">Estado</th>
                            <th scope="col">Folio</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(data || []).map((progress, i) => {
                            return (
                                <tr key={i}>
                                    <td>
                                        <div className="d-flex align-items-center" style={{ whiteSpace: 'pre-line' }}>
                                            <div className="flex-grow-1 ms-2">{progress.firmante}</div>
                                        </div>
                                    </td>
                                    <td>
                                        {' '}
                                        <a href={`${progress.link}`} target="_blank">
                                            {' '}
                                            Firmar contrato
                                        </a>{' '}
                                    </td>
                                    <td>
                                        <Badge
                                            className={classNames({
                                                'bg-success-lighten text-success': progress.status === 'signed',
                                                'bg-danger-lighten text-danger': progress.status === 'new',
                                                'bg-warning-lighten text-warning': progress.status === 'pending',
                                                'bg-primary-lighten text-primary': progress.status === 'link-opened',
                                            })}>
                                            {progress.status === 'signed' && 'Firmado'}
                                            {progress.status === 'new' && 'Nuevo'}
                                            {progress.status === 'pendiente' && 'Pendiente'}
                                            {progress.status === 'link-opened' && 'Link abierto'}
                                        </Badge>
                                    </td>
                                    <td>
                                        <Badge
                                            className={classNames({
                                                'bg-success-lighten text-success': progress.estado,
                                                'bg-danger-lighten text-danger': !progress.estado,
                                            })}>
                                            {progress.estado ? 'Vigente' : 'Obsoleto'}
                                        </Badge>
                                    </td>
                                    <td>{progress.folio}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default ContratoUs;
